/**
 * Initialize the pagination filter.
 *
 * @param {Function} callback The callback function to execute after processing.
 */
const init = (callback) => {
	// Event handler for click on pagination filter
	document.addEventListener('click', async function (e) {
		if (e.target.matches('.js-gsfc-filter-pagination')) {
			e.preventDefault();
			await process(e.target);
			// Scroll to feed anchor with smooth behavior
			document.getElementById('filterWrapper').scrollIntoView({
				behavior: 'smooth',
			});
			// Execute callback with parameters indicating no error and no additional data
			callback(false, false);
		}
	});
};

/**
 * Process the pagination filter.
 *
 * @param {HTMLElement} elem The element representing the pagination filter.
 * @return {Promise} A Promise that resolves after processing the filter.
 */
const process = (elem) => {
	return new Promise((resolve) => {
		const value = elem.dataset.page;

		// Update global filters with selected page value
		global.filters.page = value;

		resolve();
	});
};

/**
 * Update the pagination filter.
 *
 * @param {boolean} resetPage Flag indicating whether to reset the page to the first page.
 */
const update = (resetPage) => {
	// Reset page to first page if specified
	if (resetPage === true) {
		global.filters.page = 1;
	}
};

// Export the pagination filter methods
export default { init, update };
